import React, { useState, useRef, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from "framer-motion";
import { Container, Row, Col } from "react-bootstrap";
import Carousel from 'react-bootstrap/Carousel';
import Modal from 'react-bootstrap/Modal';
import CarouselNavHelper from '../../helpers/CarouselNavHelper';
import IntroOne from '../StudyOneInstructions/Intro_one';
import IntroTwo from '../StudyOneInstructions/IntroTwo';
import IntroThree from '../StudyOneInstructions/IntroThree';
import IntroWelcome from '../StudyOneInstructions/Intro_welcome';
import IntroWarmUp from '../StudyOneInstructions/Intro_warmup';
import './IntroWithConsent.css';
import { StudyProgressContext } from '../../Context';
import StudyProgressConfig from '../../helpers/StudyProgressBarConfig';

const IntroWithConsent = () => {
    const [carouselState, setCarouselState] = useState({
        index: 0,
        direction: null,
        carouselItemCount: 5
    });

    const navigate = useNavigate();
    const carouselNavHelper = new CarouselNavHelper();
    const [isLastPage, setIsLastPage] = useState(false);
    const [isFirstPage, setIsFirstPage] = useState(true);
    const [termsAgreed, setTermsAgreed] = useState(true);

    const [showModal, setShowModal] = useState(false);
    const [ModalMessage, setModalMessage] = useState('');
    const [ModalTitle, setModalTitle] = useState('');

    const contentRefs = useRef([]);
    const [isNextEnabled, setIsNextEnabled] = useState(false);

    const { studyProgress, setStudyProgress } = useContext(StudyProgressContext);
    const progressByPageConfig = new StudyProgressConfig().getConsentAndStudyOneProgressByPageConfig();

    // Create a resize observer to detect when elements are resized
    const resizeObserver = useRef(null);

    const handleScroll = (index) => {
        const content = contentRefs.current[index];
        const isEnable = carouselNavHelper.allowNextButton(index, content, termsAgreed);
        setIsNextEnabled(isEnable);
    };

    useEffect(() => {
        const content = contentRefs.current[carouselState.index];
    
        // Disconnect any previous observer
        if (resizeObserver.current) {
            resizeObserver.current.disconnect();
        }
    
        // Create a new ResizeObserver to monitor size changes of the content
        resizeObserver.current = new ResizeObserver(() => {
            const content = contentRefs.current[carouselState.index];
            const isEnable = carouselNavHelper.allowNextButton(carouselState.index, content, termsAgreed);
            setIsNextEnabled(isEnable);
        });
    
        // Observe the current content
        if (content) {
            resizeObserver.current.observe(content);
        }
    
        return () => {
            if (resizeObserver.current) {
                resizeObserver.current.disconnect();
            }
        };
    }, [carouselState.index, termsAgreed]);

    const handleShowModal = (isShow, title, message) => {
        setShowModal(isShow);

        if (title) setModalTitle(title);
        if (message) setModalMessage(message);
    };

    const toggleCarousel = (direction) => {
        let index = carouselState.index;
        const [min, max] = [0, carouselState.carouselItemCount - 1];
        setIsLastPage(false);
        setIsFirstPage(false);

        if (direction === 'next') {
            index++;
        } else if (direction === 'prev') {
            index--;
        }

        setStudyProgress(progressByPageConfig[index]);

        if (index >= max) {
            index = max;
            setIsLastPage(true);
        }

        if (index <= min) {
            index = min;
            setIsFirstPage(true);
        }

        setCarouselState({
            ...carouselState,
            index,
            direction
        });

        // Reset next button enabled state
        setIsNextEnabled(false);
    };

    return (
        <div className="content">
            <div className="tabcontent">
                <div className="container message-card carousel-container">

                    <Carousel activeIndex={carouselState.index} direction={carouselState.direction} interval={null} controls={false}>
                        <Carousel.Item>
                            <Container className="study-item" style={{ maxHeight: '80vh', overflowY: 'auto' }}
                                ref={(el) => (contentRefs.current[0] = el)} 
                                onScroll={() => handleScroll(0)}
                            >
                                <IntroWelcome/>
                            </Container>
                        </Carousel.Item>
                        <Carousel.Item>
                            <Container className="study-item" style={{ maxHeight: '80vh', overflowY: 'auto' }}
                                ref={(el) => (contentRefs.current[1] = el)} 
                                onScroll={() => handleScroll(1)}
                            >
                                <IntroWarmUp/>
                            </Container>
                        </Carousel.Item>
                        <Carousel.Item>
                            <Container className="study-item" style={{ maxHeight: '80vh', overflowY: 'auto' }}
                                ref={(el) => (contentRefs.current[2] = el)} 
                                onScroll={() => handleScroll(2)}
                            >
                                <IntroOne/>
                            </Container>
                        </Carousel.Item>
                        <Carousel.Item>
                            <Container className="study-item" style={{ maxHeight: '80vh', overflowY: 'auto' }}
                                ref={(el) => (contentRefs.current[3] = el)} 
                                onScroll={() => handleScroll(3)}
                            >
                                <IntroTwo/>
                            </Container>
                        </Carousel.Item>
                        <Carousel.Item>
                            <Container className="study-item" style={{ maxHeight: '80vh', overflowY: 'auto' }}
                                ref={(el) => (contentRefs.current[4] = el)} 
                                onScroll={() => handleScroll(4)}
                            >
                                <IntroThree/>
                            </Container>
                        </Carousel.Item>
                        {/* <Carousel.Item>
                            <Container className="study-item" style={{ maxHeight: '80vh', overflowY: 'auto' }}
                                ref={(el) => (contentRefs.current[6] = el)} 
                                onScroll={() => handleScroll(6)}
                            >
                                <StudyOneInstructionPageTwo />
                            </Container>
                        </Carousel.Item> */}
                        
                    </Carousel>
                    <div className="carousel-button-container">
                        {isFirstPage ? null : (
                            <motion.button
                                type="button"
                                className="button carousel-button"
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.8 }}
                                onClick={() => toggleCarousel('prev')}
                            >
                                <i className='bx bx-arrow-back'/>
                                {/* Previous */}
                            </motion.button>
                        )}
                        {isLastPage ? (
                            <motion.button
                                type="button"
                                className={`button carousel-button button-green ${isNextEnabled ? '' : 'button-disabled'}`}
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.8 }}
                                onClick={() => {
                                    toggleCarousel('next');
                                    navigate("/explore");
                                }}
                                disabled={!isNextEnabled}
                            >
                                Start!
                            </motion.button>
                        ) : (
                            <motion.button
                                type="button"
                                className={`button carousel-button ${isNextEnabled ? '' : 'button-disabled'}`}
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.8 }}
                                onClick={() => toggleCarousel('next')}
                                disabled={!isNextEnabled}
                            >
                                <i className='bx bx-arrow-back bx-rotate-180' />
                                {/* Next */}
                            </motion.button>
                        )}
                    </div>

                    <Modal show={showModal} onHide={() => handleShowModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>{ModalTitle}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>{ModalMessage}</Modal.Body>
                        <Modal.Footer>
                            <motion.button
                                type="button"
                                className="button carousel-button"
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.8 }}
                                onClick={() => handleShowModal(false)}
                            >
                                Got it!
                            </motion.button>
                        </Modal.Footer>
                    </Modal>

                </div>
            </div>
        </div>
    );
};

export default IntroWithConsent;
